import React, { useState } from "react";
import "./Login.css";
import fundo from "../assets/fundo.png";
export default function Login({ onLogin }) {
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");

  const handleLogin = () => {
    if (usuario === "admin" && senha === "1234") {
      onLogin(true);
    } else {
      setErro("Usuário ou senha incorretos.");
    }
  };

  return (
    // <div className="login-page">
          <div className="login-page" style={{ backgroundImage: `url(${fundo})` }}>
      <div className="login-container">
        <h1 className="titleStyle" >Portal RPA - Demonstrativo</h1>
        <p className="subtitle">Automação inteligente em ação</p>

        <input
          type="text"
          placeholder="Usuário"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
        />
        <input
          type="password"
          placeholder="Senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        <button className="entrar" onClick={handleLogin}>Entrar</button>
        {erro && <p className="error">{erro}</p>}
      </div>
    </div>
  );
}
